import { GlobalToken } from 'antd/es/theme/interface'
import { CellValidator } from '../cell-validators'
import { getShipmentDisplayCalculated } from '../entities/shipment/get-shipment-display-calculated'

const markupBelowRecommended = (costOfAllCopies: number, marginRatio: number): boolean => {
    if (costOfAllCopies > 16000 && costOfAllCopies <= 30000 && marginRatio < 2.3) return true
    if (costOfAllCopies > 30000 && costOfAllCopies <= 50000 && marginRatio < 2.2) return true
    if (costOfAllCopies > 50000 && costOfAllCopies <= 100000 && marginRatio < 2.1) return true
    if (costOfAllCopies > 100000 && costOfAllCopies <= 170000 && marginRatio < 2.0) return true
    if (costOfAllCopies > 170000 && costOfAllCopies <= 250000 && marginRatio < 1.9) return true
    if (costOfAllCopies > 250000 && marginRatio < 1.8) return true
    return false
}

export const validateCostOfAllCopies: CellValidator = (record, token: GlobalToken) => {
    const calculated = getShipmentDisplayCalculated(record)
    const costOfAllCopies = calculated?.costOfAllCopies
    const marginRatio = calculated?.marginRatio
    const profitOfAllCopies = calculated?.profitOfAllCopies

    if (
        costOfAllCopies === undefined ||
        marginRatio === undefined ||
        profitOfAllCopies === undefined
    ) {
        return null
    }

    if (costOfAllCopies <= 16000 && profitOfAllCopies < 20000) {
        return {
            message: 'Себестоимость 16к и меньше, прибыль менее 20к',
            color: token.colorErrorText || token.colorError,
        }
    }

    if (markupBelowRecommended(costOfAllCopies, marginRatio)) {
        return {
            message: 'Наценка ниже рекомендуемой для данной себестоимости',
            color: token.colorWarningText || token.colorWarning,
        }
    }

    return null
}
